module.exports = __webpack_public_path__ + "static/media/slideshow-14.b3adcee7.jpeg";